import React, { lazy } from 'react';
import { Check } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { CTAButton } from './CTAButton';
import { UrgencyTimer } from './UrgencyTimer';
import { TrustBadges } from './TrustBadges';
const features = ['200 recetas diseñadas para congelar', 'Opciones clásicas, rápidas y vegetarianas', 'Con calorías y macros calculadas', 'Versiones sin gluten / sin lactosa', 'Adaptables a 1, 2 o 4 personas'];
export function WhatYouGet() {
  return <section className="py-5 md:py-7 px-4 bg-white" data-id="element-269">
      <div className="max-w-5xl mx-auto" data-id="element-270">
        <h2 className="text-xl md:text-3xl text-center mb-4 md:mb-5 font-bold tracking-tight" data-id="element-271">
          Esto es lo que recibís hoy
        </h2>

        <div className="bg-white border border-black/10 overflow-hidden rounded-2xl shadow-sm" data-id="element-272">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-273">
            <div className="bg-[#F7F5F0] p-4 md:p-6 flex items-center justify-center border-b lg:border-b-0 lg:border-r border-black/5" data-id="element-274">
              <div className="w-full rounded-2xl overflow-hidden shadow-md border border-black/10 flex items-center justify-center transform -rotate-1" style={{
              aspectRatio: '16/9'
            }} data-id="element-275">
                <img src="https://cdn.magicpatterns.com/uploads/8ftLEeK2RTLSdnhb697fhV/Mockup_Oferta.png" alt="200 Recetas Inteligentes 15D" width={1920} height={1080} className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-276" />
              </div>
            </div>

            <div className="p-4 md:p-6 flex flex-col justify-center" data-id="element-277">
              <h3 className="text-lg md:text-xl font-bold mb-2 text-text-primary tracking-tight" data-id="element-278">
                200 Recetas Inteligentes 15D
              </h3>
              <p className="text-xs md:text-sm text-text-primary/80 mb-4 md:mb-5 font-medium" data-id="element-279">
                Prepará 15 días de comidas en 2 horas sin dietas estrictas ni
                delivery.
              </p>

              <div className="mb-5 md:mb-6" data-id="element-280">
                <p className="font-bold text-text-primary mb-2 md:mb-3 text-xs uppercase tracking-wide" data-id="element-281">
                  Incluye:
                </p>
                <ul className="space-y-1.5" data-id="element-282">
                  {features.map((feature, i) => <li key={i} className="flex items-start gap-2" data-id="element-283">
                      <Check className="text-primary flex-shrink-0 mt-0.5" size={16} data-id="element-284" />
                      <span className="text-text-primary/90 text-xs md:text-sm font-bold" data-id="element-285">
                        {feature}
                      </span>
                    </li>)}
                </ul>
              </div>

              <div className="bg-[#F7F5F0] p-2.5 md:p-4 mb-4 md:mb-5 text-center border border-black/5 rounded-2xl" data-id="element-286">
                <p className="text-[10px] md:text-xs text-text-primary/60 mb-1 uppercase tracking-widest font-bold" data-id="element-287">
                  Valor real
                </p>
                <PriceDisplay amount={19990} showOriginal={true} originalAmount={39990} data-id="element-288" />
              </div>

              <CTAButton large data-id="element-289">QUIERO EL SISTEMA</CTAButton>
              <p className="text-center text-[10px] md:text-xs text-text-primary/60 mt-2 md:mt-3 font-bold uppercase tracking-wide" data-id="element-290">
                Pago Único. Sin Cargos Mensuales
              </p>
            </div>
          </div>
        </div>

        <div className="mt-4 md:mt-5" data-id="element-291">
          <UrgencyTimer data-id="element-292" />
          <TrustBadges data-id="element-293" />
        </div>
      </div>
    </section>;
}